import { useMutation, useQueryClient } from "@tanstack/react-query";
import { alertSchemaService } from "../../../services/alertSchemasService";
import type { AlertSchema } from "../../../types";

export const useUpdateAlertSchema = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      alertSchemaId,
      alertSchema,
    }: {
      alertSchemaId: string;
      alertSchema: Partial<Omit<AlertSchema, "id" | "system">>;
    }) => {
      const updated = await alertSchemaService.patch(alertSchemaId, alertSchema);
      return { updated, alertSchemaId };
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["alert-providers"] });
    },
  });
};
